import React, { Component } from "react";
import TopSignNav from "../../overlays/topSignNav/topSignNav";
import VideoHead from "../../video/VideoHead";
import Row from "../../containers/row";
import ImageHead from "../../imageHead";
import OverlayTop from "../../overlays/overlayTop/overlayTop";
import BoxLinks from "../../overlays/boxLinks/boxLinks";
import TopSignSmall from "../../overlays/topSignSmall/topSignSmall";
//import {gutter} from '../../config/vars';

class TopRow extends Component {
  renderBackground() {
    switch (this.props.media[0].bundle) {
      case "video_with_description":
        return (
          <VideoHead
            className="headVideo"
            id="headerVideo"
            width="100%"
            autoPlay="autoplay"
            loop="loop"
            media={this.props.media[0].field_link_2}
          />
        );
      case "image_with_description":
        return <ImageHead media={this.props.media[0].field_image} />;
      case "image_slideshow":
        return <p>TO DO Slides</p>;

      default:
        return <p>A Video, Image or Slide must be added</p>;
    }
  }

  renderOverlay() {
    switch (this.props.type) {
      case "1":
        if (window.innerWidth > 899) {
          return (
            <TopSignNav
              blockStyle={this.props.blockStyle.attributes}
              style={{
                position: "absolute",
                top: "2%",
                right: "24px",
              }}
              links={this.props.links}
              data={this.props.media}
            />
          );
        } else {
          return (
            <TopSignSmall
              blockStyle={this.props.blockStyle.attributes}
              links={this.props.links}
              data={this.props.media}
            />
          );
        }
      case "2":
        return (
          <OverlayTop
            data={this.props.media}
            style={{
              position: window.innerWidth > 899 ? "absolute" : "relative",
              top: "0px",
              right: "0px",
              width: window.innerWidth > 899 ? "375px" : "100%",
              height: "100%",
              overflow: "hidden",
              padding: "14px 24px 24px 24px",
            }}
            blockStyle={this.props.blockStyle}
          />
        );
      case "3":
        return (
          <BoxLinks
            data={this.props}
            nid={this.props.nid}
            style={{
              boxSizing: "border-box",
              position: "absolute",
              top: window.innerWidth > 899 ? "3%" : "0",
              left: "25px",
              zIndex: "1000",
            }}
          />
        );

      case "4":
        return (
          <OverlayTop
            data={this.props.media}
            style={{
              position: window.innerWidth > 899 ? "absolute" : "relative",
              float: window.innerWidth > 899 ? "null" : "left;clear:both",
              bottom: window.innerWidth > 899 ? "120px" : "16px",
              right: "0px",
              width: window.innerWidth > 899 ? "366px" : "100%",
              height: "211px",
              overflow: "hidden",
              padding: "10px 24px 24px 24px",
              boxSizing: "border-box",
            }}
            blockStyle={this.props.blockStyle}
          />
        );
      default:
        return null;
    }
  }

  render() {
    return (
      <Row
        className="topRow"
        padding="0"
        bgi="none"
        display="block"
        styles={{
          position: "relative",
          width: "100%",
          textAlign: "left",
        }}
      >
        {this.renderBackground()}
        {this.renderOverlay()}
      </Row>
    );
  }
}

export default TopRow;
